import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVectorUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.97221 1.27734C3.97221 1.69734 4.30971 2.02734 4.72221 2.02734H8.91471L0.747207 10.1948C0.454707 10.4873 0.454707 10.9598 0.747207 11.2523C1.03971 11.5448 1.51221 11.5448 1.80471 11.2523L9.97221 3.08484V7.27734C9.97221 7.68984 10.3097 8.02734 10.7222 8.02734C11.1347 8.02734 11.4722 7.68984 11.4722 7.27734V1.27734C11.4722 0.864844 11.1347 0.527344 10.7222 0.527344H4.72221C4.30971 0.527344 3.97221 0.864844 3.97221 1.27734Z",
		fill: "#1D1D1D"
	})
});
export default SvgVectorUp;
